import Transfer from "manifest-components/src/classes/transfer";
import TransferSource from "manifest-components/src/classes/transferSource";
import TransferOptions from "manifest-components/src/classes/transferOptions";
import { TransferState } from "./transferState";
import { Action, Actions } from "./transferActions";

export default (state: typeof TransferState, action: Action): typeof TransferState => {
  switch (action.type) {
    case Actions.UPDATING_TRANSFER_SOURCE:
      return {
        ...state,
        transferSourcesUpdating: true,
      };

    case Actions.UPDATE_TRANSFER_SOURCE:
      return {
        ...state,
        transferSourcesUpdating: false,
      };

    case Actions.UPDATING_TRANSFER_DESTINATION:
      return {
        ...state,
        transferDestinationUpdating: true,
      };

    case Actions.UPDATE_TRANSFER_DESTINATION:
      return {
        ...state,
        transferDestinationUpdating: false,
        transferDestination: action.payload,
        transferDestinationFetched: true,
        transferDestinationFetching: false,
      };

    case Actions.SHOW_ALL_TRANSFERS:
      return {
        ...state,
        showAllTransfers: true,
      };

    case Actions.SHOW_CURRENT_TRANSFER:
      return {
        ...state,
        showAllTransfers: false,
      };

    case Actions.INITIATE_NEW_TRANSFER:
      return {
        ...state,
        currentTransfer: action.payload,
        transferOptionsFetched: false,
        fetchingTransferOptions: false,
      };

    case Actions.UPDATE_TRANSFER_ID: {
      return {
        ...state,
        // inProgressTransfersFetched: false
      };
    }

    case Actions.SET_CURRENT_TRANSFER:
      return {
        ...state,
        currentTransfer: action.payload.data,
        fetchingCurrentTransfer: false,
        currentTransferFetched: true,
      };

    case Actions.GET_IN_PROGRESS_TRANSFERS:
      return {
        ...state,
        inProgressTransfers: action.payload,
        inProgressTransfersFetched: true,
        fetchingInProgressTransfers: false,
      };

    case Actions.GET_INITIATED_TRANSFERS:
      return {
        ...state,
        initiatedTransfers: action.payload,
        initiatedTransfersFetched: true,
        fetchingInitiatedTransfers: false,
      };
    case Actions.GET_QUEUED_TRANSFERS:
      return {
        ...state,
        queuedTransfers: action.payload,
        queuedTransferFetched: true,
        fetchingInitiatedTransfers: false,
      };

    case Actions.GET_PROVIDERS_LIST:
      return {
        ...state,
        providersList: action.payload,
        fetchingProvidersList: false,
        providersListFetched: true,
      };

    case Actions.GET_COMPLETE_TRANSFERS:
      return {
        ...state,
        completeTransfers: action.payload,
        completeTransfersFetched: true,
        fetchingCompletedTransfers: false,
      };

    case Actions.GET_TRANSFER_INSTRUCTIONS_WITH_USER_INPUT_NEEDED:
      return {
        ...state,
        transferInstructionsWithUserInputNeeded: action.payload,
        transferInstructionsWithUserInputNeededFetched: true,
        fetchingTransferInstructions: false,
      };

    case Actions.GET_CANCELLED_TRANSFERS:
      return {
        ...state,
        cancelledTransfers: action.payload,
        cancelledTransfersFetched: true,
        fetchingCancelledTransfers: false,
      };
    case Actions.GET_WAIT_FOR_IRA_TRANSFER:
      return {
        ...state,
        transferInstructionsWithIRAOpening: action.payload,
      };

    case Actions.GET_ROTH_TRANSFERRED_DESTINATIONS:
      return {
        ...state,
        rothTransferredDestinations: action.payload,
        rothTransferredDestinationsFetched: true,
        loadingTransfer: true,
      };

    case Actions.GET_TRANSFERRED_DESTINATIONS: {
      return {
        ...state,
        transferredDestinations: action.payload,
        transferredDestinationsFetched: true,
        fetchingTransferredDestinations: false,
        loadingTransfer: true,
      };
    }

    case Actions.SET_LOADING:
      return {
        ...state,
        loadingTransfer: action.payload,
      };

    case Actions.FETCHING_TRANSFER_INSTRUCTIONS_WITH_USER_INPUT_NEEDED:
      return {
        ...state,
        fetchingTransferInstructions: true,
      };

    case Actions.FETCHING_CANCELLED_TRANSFERS:
      return {
        ...state,
        fetchingCancelledTransfers: true,
      };

    case Actions.FETCHING_COMPLETE_TRANSFERS:
      return {
        ...state,
        fetchingCompletedTransfers: true,
      };

    case Actions.FETCHING_INITIATED_TRANSFERS:
      return {
        ...state,
        fetchingInitiatedTransfers: true,
      };

    case Actions.FETCHING_IN_PROGRESS_TRANSFERS:
      return {
        ...state,
        fetchingInProgressTransfers: true,
      };

    case Actions.FETCHING_CURRENT_TRANSFER: {
      return {
        ...state,
        fetchingCurrentTransfer: true,
      };
    }

    case Actions.FETCHING_PROVIDERS_LIST: {
      return {
        ...state,
        fetchingProvidersList: true,
      };
    }

    case Actions.FETCHING_TRANSFERRED_DESTINATIONS: {
      return {
        ...state,
        fetchingTransferredDestinations: true,
      };
    }

    case Actions.REMOVE_TRANSFER:
      return {
        ...state,
        inProgressTransfers: [],
        inProgressTransfersFetched: false,
        initiatedTransfers: [],
        initiatedTransfersFetched: false,
        completeTransfers: [],
        completeTransfersFetched: false,
        manualAccountConnected: false,
        loadingTransfer: true,
        transferDataRemoved: true,
        transferredDestinations: [],
        transferredDestinationsFetched: false,
        currentTransfer: new Transfer(),
        currentTransferFetched: false,
      };

    case Actions.FETCHING_TRANSFER_OPTIONS:
      return {
        ...state,
        fetchingTransferOptions: true,
      };

    case Actions.GET_TRANSFER_OPTIONS:
      return {
        ...state,
        transferOptionsFetched: true,
        fetchingTransferOptions: false,
        transferOptions: action.payload,
      };

    case Actions.GET_IRA_OPTIONS:
      return {
        ...state,
        iraOptions: action.payload,
      };

    case Actions.REMOVE_DATA:
      return {
        ...state,
        transferInstructionsWithUserInputNeeded: [],
        transferInstructionsWithUserInputNeededFetched: false,
        inProgressTransfers: [],
        inProgressTransfersFetched: false,
        initiatedTransfers: [],
        initiatedTransfersFetched: false,
        completeTransfers: [],
        completeTransfersFetched: false,
        transferredDestinations: [],
        transferredDestinationsFetched: false,
        currentPlanData: {} as TransferSource,
        planDataFetched: false,
        providerMailingDetails: {},
        providersList: [],
        manualAccountConnected: false,
        providersListFetched: false,
        transferOptions: new TransferOptions(),
        mailingDetailsFetched: false,
        showAllTransfers: true,
        transferDataRemoved: false,
        loadingTransfer: true,
        currentTransfer: new Transfer(),
        currentTransferFetched: false,
        dataRemoved: true,
        statementUrlFetched: false,
        destinationConnectedToTransfer: false,
        statementUrl: "",
        statementFiles: [],
        statementFilesFetched: false,
        statementUrlRemoved: true,
        statementAccountsConnected: false,
        statementAccountsFetched: false,
      };

    case Actions.CONNECT_DESTINATION_TO_TRANSFER: {
      return {
        ...state,
        destinationConnectedToTransfer: true,
      };
    }

    default:
      return state;
  }
};
